/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface NumericEvaluationResultDto
 */
export interface NumericEvaluationResultDto {
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    evaluationParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof NumericEvaluationResultDto
     */
    evaluationOutcome?: EvaluationState;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericEvaluationResultDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof NumericEvaluationResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof NumericEvaluationResultDto
     */
    lastModifierUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    dataSetId?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof NumericEvaluationResultDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    actualValue?: number;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    deviationValue?: number;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    deviationUnit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericEvaluationResultDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    $type?: NumericEvaluationResultDtoTypeEnum;
}


/**
 * @export
 */
export const NumericEvaluationResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoNumericEvaluationResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericEvaluationResultDtoTypeEnum = typeof NumericEvaluationResultDtoTypeEnum[keyof typeof NumericEvaluationResultDtoTypeEnum];


/**
 * Check if a given object implements the NumericEvaluationResultDto interface.
 */
export function instanceOfNumericEvaluationResultDto(value?: unknown): value is NumericEvaluationResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericEvaluationResultDtoTypeEnum)[0];
}

export function NumericEvaluationResultDtoFromJSON(json: any): NumericEvaluationResultDto {
    return NumericEvaluationResultDtoFromJSONTyped(json, false);
}

export function NumericEvaluationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'evaluationParameterId': !exists(json, 'evaluationParameterId') ? undefined : json['evaluationParameterId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'evaluationOutcome': !exists(json, 'evaluationOutcome') ? undefined : EvaluationStateFromJSON(json['evaluationOutcome']),
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'dataSetId': !exists(json, 'dataSetId') ? undefined : json['dataSetId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'actualValue': !exists(json, 'actualValue') ? undefined : json['actualValue'],
        'deviationValue': !exists(json, 'deviationValue') ? undefined : json['deviationValue'],
        'deviationUnit': !exists(json, 'deviationUnit') ? undefined : json['deviationUnit'],
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericEvaluationResultDtoToJSON(value?: NumericEvaluationResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'evaluationParameterId': value.evaluationParameterId,
        'name': value.name,
        'evaluationOutcome': EvaluationStateToJSON(value.evaluationOutcome),
        'origin': EntityOriginToJSON(value.origin),
        'iuid': value.iuid,
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.creatorUser),
        'lastModifierUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.lastModifierUser),
        'dataSetId': value.dataSetId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'actualValue': value.actualValue,
        'deviationValue': value.deviationValue,
        'deviationUnit': value.deviationUnit,
        'decimalPlaces': value.decimalPlaces,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

